const logoPaginaDofollow = 'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Sponsorship Comercio Corporativo',
    annualPrice: 'Trimestral: 360',
    monthlyPrice: 120,
    features: [
      'Tres menciones en vivo: al entrar, en el desarrollo (aquí se explica tu marca) y salida',
      'Video comercial de 20 segundos durante el programa',
      'Presencia en transmisión en vivo por TNO Network',
      'Presencia en Web, App y Redes Sociales',
      'Asociación con economía, gestión y éxito empresarial',
      logoPaginaDofollow,
    ],
    idealFor: 'Bancos, aseguradoras, consultoras, tecnología B2B y marcas corporativas.',
    duration: 'Mensual',
    buttonText: 'Patrocinar Comercio Corporativo',
    highlightedTitle: 'Autoridad empresarial',
    highlightedContent: [
      'Tu marca viaja con la credibilidad de Darío Ascanio.',
      'Tres menciones + un comercial de 20 segundos dentro del programa.',
      'Economía, gestión y negociación en un solo espacio.',
    ],
    highlightedButtonText: 'Ver Demo del Programa',
  },
  {
    title: 'Segmento Exclusivo por Tema',
    annualPrice: 'Trimestral: 180',
    monthlyPrice: 60,
    features: [
      'Mención exclusiva: "Este segmento presentado por..."',
      'Vinculación con una temática: Economía, Gestión, Finanzas o Emprendimiento',
      'Contenido alineado con el ADN de tu marca',
      'Presencia en el bloque correspondiente del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas especializadas que buscan relevancia temática en negocios.',
    duration: 'Suscripción Mensual',
    buttonText: 'Elegir mi Tema',
    highlightedTitle: 'Liderazgo de categoría',
    highlightedContent: [
      'Tu marca se convierte en referente del segmento elegido.',
      'Asociación orgánica con tomadores de decisión.',
      'Ideal para campañas B2B y posicionamiento institucional.',
    ],
    highlightedButtonText: 'Ver Temas Disponibles',
  },
  {
    title: 'Entrevista Patrocinada',
    annualPrice: 'Por sesión: 40',
    monthlyPrice: 40,
    features: [
      'Entrevista de 20 minutos en vivo',
      'Proyección de tus videos promocionales',
      'Mención de sedes, servicios o puntos de contacto',
      'Propuesta con respaldo visual en pantalla',
      'Post en redes sociales del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'CEOs, gremios, franquicias y voceros de marcas corporativas.',
    duration: '20 minutos por sesión',
    buttonText: 'Agendar Entrevista',
    highlightedTitle: 'Caso de éxito en antena',
    highlightedContent: [
      'Proyección de videos promocionales durante la entrevista.',
      'Narrativa de marca con tono analítico de Comercio Corporativo.',
    ],
    highlightedButtonText: 'Consultar Fechas',
  },
  {
    title: 'Post Patrocinado en TNO Digest',
    annualPrice: 'Por publicación: 50',
    monthlyPrice: 50,
    features: [
      'Publicación patrocinada en las redes sociales de TNO Digest',
      'Alcance en el ecosistema digital de Comercio Corporativo y TNO Digest',
      'Contenido adaptado a economía y negocios',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan visibilidad en redes sin compromiso de programa en vivo.',
    duration: 'Por publicación',
    buttonText: 'Solicitar Post Patrocinado',
    highlightedTitle: 'Visibilidad en TNO Digest',
    highlightedContent: [
      'Tu marca en el feed oficial de TNO Digest.',
      'Ideal para lanzamientos o reforzar una campaña B2B.',
    ],
    highlightedButtonText: 'Solicitar Post',
  },
  {
    title: 'Cápsula Corporativa / Marca',
    annualPrice: 'Pack 5 Cápsulas: 150',
    monthlyPrice: 40,
    features: [
      'Cápsula de 60-90 segundos con estética del programa',
      'Distribución en redes sociales de TNO y del programa',
      'Tema: gestión, finanzas o promoción de servicios',
      'Locución profesional en línea con el tono del show',
      logoPaginaDofollow,
    ],
    idealFor: 'Promociones institucionales, informes y lanzamientos de producto B2B.',
    duration: 'Por cápsula',
    buttonText: 'Solicitar Cápsula',
    highlightedTitle: 'Atención en Redes',
    highlightedContent: [
      'Tu mensaje en el ecosistema de Comercio Corporativo.',
      'Formato breve y memorable para máxima recordación.',
    ],
    highlightedButtonText: 'Enviar mi Propuesta',
  },
  {
    title: 'UGC Corporativo',
    annualPrice: '80 por pieza',
    monthlyPrice: 80,
    features: [
      'Video estilo testimonio ejecutivo o caso de éxito con el producto',
      'Demostración en contexto empresarial real',
      'Narrativa humana alineada con gestión y resultados',
      'Publicación del video en TNO y en Comercio Corporativo',
      'Entrega de archivo original para pauta publicitaria de la marca',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas de servicios profesionales, fintech y soluciones empresariales.',
    duration: 'Por pieza',
    buttonText: 'Activar Campaña UGC',
    highlightedTitle: 'Prueba social B2B',
    highlightedContent: [
      'Contenido UGC con tono del programa y credibilidad de la ancla.',
      'Tu marca como recomendación de un aliado, no como anuncio frío.',
    ],
    highlightedButtonText: 'Activar Campaña UGC',
  },
];

export default optionsData;
